import React, { Component } from 'react';
import Button from '../../../components/button/Button';
import Toast from '../../../components/toast/Toast';
import { setDetectSpeed } from '../../../service/command';

const modules = [
  {
    label: '快',
    value: '-1'
  },
  {
    label: '中',
    value: '0'
  },
  {
    label: '慢',
    value: '1'
  }
];

export default class DetectSpeed extends Component {
  constructor(props) {
    super(props);
    this.state = {
      inSpeed: '0',
      outSpeed: '-1'
    };
  }

  onSelect(type, e) {
    this.setState({
      [type === 'in' ? 'inSpeed' : 'outSpeed']: e.target.value
    });
  }

  onConfirm() {
    const loading = Toast.loading('正在修改检测速度');

    setDetectSpeed(this.state.inSpeed, this.state.outSpeed).then(() => {
      Toast.success('修改成功');
    }).catch((error) => {
      Toast.fail(error);
    }).then(() => {
      loading.destroy();
    });
  }

  render() {
    return (
      <div>
        <h4 className="popup-title">修改检测速度</h4>
        <div style={{ display: 'flex', marginBottom: 10 }}>
          <span>进车：</span>
          <select style={{ flex: 1, border: '1px solid #ccc', background: '#fff' }} onChange={e => this.onSelect('in', e)} defaultValue={this.state.inSpeed}>
            {
              modules.map(item => (
                <option key={item.value} value={item.value}>{item.label}</option>
              ))
            }
          </select>
        </div>
        <div style={{ display: 'flex' }}>
          <span>出车：</span>
          <select style={{ flex: 1, border: '1px solid #ccc', background: '#fff' }} onChange={e => this.onSelect('out', e)} defaultValue={this.state.outSpeed}>
            {
              modules.map(item => (
                <option key={item.value} value={item.value}>{item.label}</option>
              ))
            }
          </select>
        </div>
        <div style={{ textAlign: 'center' }}>
          <Button type="primary" onClick={() => this.onConfirm()}>确认修改</Button>
        </div>
      </div>
    );
  }
}
